import { inject } from '@angular/core';
import { HostedGamesService } from '@hosted-games/infra';
import { map, Observable, take } from 'rxjs';
import { GameDetailsModel, mapHostedGameDetailsDto } from '@core';
import { GetHostedGamePathParams, HostedGameDetailsDto } from '@core-http';

export class GetHostedGameQueryHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);

  getGame(gameId: string): Observable<GameDetailsModel> {
    const pathParams: GetHostedGamePathParams = { hostedGameId: gameId };

    return this.hostedGamesService.getOneGame(pathParams).pipe(
      take(1),
      map((game: HostedGameDetailsDto) => mapHostedGameDetailsDto(game))
    );
  }
}
